/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a new claim pipeline
 * @export
 * @interface CreateClaimPipelineRequest
 */
export interface CreateClaimPipelineRequest {
    /**
     * Pipeline name
     * @type {string}
     * @memberof CreateClaimPipelineRequest
     */
    name: string;
    /**
     * Optional description of the pipeline
     * @type {string}
     * @memberof CreateClaimPipelineRequest
     */
    description?: string | null;
    /**
     * Optional hex color code for pipeline display (e.g., "#3B82F6")
     * @type {string}
     * @memberof CreateClaimPipelineRequest
     */
    color?: string | null;
    /**
     * Order in which pipelines should be displayed
     * @type {number}
     * @memberof CreateClaimPipelineRequest
     */
    displayOrder?: number;
}

/**
 * Check if a given object implements the CreateClaimPipelineRequest interface.
 */
export function instanceOfCreateClaimPipelineRequest(value: object): value is CreateClaimPipelineRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateClaimPipelineRequestFromJSON(json: any): CreateClaimPipelineRequest {
    return CreateClaimPipelineRequestFromJSONTyped(json, false);
}

export function CreateClaimPipelineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimPipelineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'color': json['color'] == null ? undefined : json['color'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
    };
}

export function CreateClaimPipelineRequestToJSON(json: any): CreateClaimPipelineRequest {
    return CreateClaimPipelineRequestToJSONTyped(json, false);
}

export function CreateClaimPipelineRequestToJSONTyped(value?: CreateClaimPipelineRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'color': value['color'],
        'displayOrder': value['displayOrder'],
    };
}

